var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiBrMemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.5,0h-7C5.468,0,3,2.468,3,5.5v13c0,3.032,2.468,5.5,5.5,5.5h7c3.032,0,5.5-2.468,5.5-5.5V5.5c0-3.032-2.468-5.5-5.5-5.5Zm2.5,18.5c0,1.379-1.121,2.5-2.5,2.5h-7c-1.379,0-2.5-1.121-2.5-2.5V5.5c0-1.379,1.121-2.5,2.5-2.5h7c1.379,0,2.5,1.121,2.5,2.5v13Zm-2-12c0,.828-.672,1.5-1.5,1.5h-5c-.828,0-1.5-.672-1.5-1.5s.672-1.5,1.5-1.5h5c.828,0,1.5.672,1.5,1.5Zm0,5c0,.828-.672,1.5-1.5,1.5h-5c-.828,0-1.5-.672-1.5-1.5s.672-1.5,1.5-1.5h5c.828,0,1.5.672,1.5,1.5Zm-3,5c0,.828-.672,1.5-1.5,1.5h-2c-.828,0-1.5-.672-1.5-1.5s.672-1.5,1.5-1.5h2c.828,0,1.5.672,1.5,1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiBrMemo);
export default __webpack_public_path__ + "static/media/fi-br-memo.ea0cbc721975bf5344e2901d8b13dd5b.svg";
export { ForwardRef as ReactComponent };